import { Constants, ROUTER_PATHS } from 'src/app/shared/constants';

export const MenuItems = [
  {
    id: ROUTER_PATHS.dashboard.root,
    title: 'Dashboard',
    icon: Constants.staticImages.icons.dashboard,
    routerLink: ROUTER_PATHS.dashboard.root,
    isAccessible: true,
    parentRoute: null,
    subMenuOptions: []
  },
  {
    id: ROUTER_PATHS.customers.root,
    title: 'Customers',
    icon: Constants.staticImages.icons.customers,
    routerLink: ROUTER_PATHS.customers.root,
    isAccessible: true,
    parentRoute: null,
    subMenuOptions: []
  },
  {
    id: ROUTER_PATHS.projects.root,
    title: 'Projects',
    icon: Constants.staticImages.icons.projects,
    routerLink: ROUTER_PATHS.projects.root,
    isAccessible: true,
    parentRoute: null,
    subMenuOptions: []
  },
  {
    id: ROUTER_PATHS.surveys.root,
    title: 'Surveys',
    icon: Constants.staticImages.icons.surveys,
    routerLink: ROUTER_PATHS.surveys.root,
    isAccessible: true,
    parentRoute: null,
    subMenuOptions: []
  }
];

export enum ToggleDirections {
  LEFT = 'left',
  RIGHT = 'right'
}
